import axios from 'axios';

const api = {
    getTimezone(location: any) {
        return axios.get(
            `https://maps.googleapis.com/maps/api/timezone/json?location=${location}&timestamp=1331161200&key=${process.env.REACT_APP_GOOGLE_KEY}`,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            { withCredentials: false, rawData: true, requestId: 'goolemap' },
        );
    },
};

export default api;
